<template>
  <div class="w-full px-2">
    <div class="w-full flex text-center pb-4 pt-2">
      <div class="flex-1 flex items-center justify-center">
        Drag 'n Drop items to reorder.
      </div>
      <a class="cursor-pointer px-4 py-2" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'times']" />
      </a>
    </div>
    <vue-draggable v-model="items">
      <div class="w-full bg-gray-300 mb-2 px-4 py-2 cursor-move flex" v-for="(item, key) in items" :key="item.id">
        <div class="flex-1">
          {{ key + 1 }}. {{ formattedCompanies(item) }}
        </div>
        <div v-if="item.monthly">Monthly</div>
        <div v-else>{{ formattedDate(item.start_date) }} - {{ formattedDate(item.end_date) }}</div>
      </div>
    </vue-draggable>
    <div class="w-full text-center pb-4 pt-2">
      <b-button @click="submit">Submit</b-button>
    </div>
  </div>
</template>

<script>
import VueDraggable from 'vuedraggable'
import {map} from 'lodash'
import {EventBus} from '../events'
import moment from 'moment'

export default {
  name: "ReorderForm",
  props: {
    existing: {
      required: true
    }
  },
  components: {
    VueDraggable
  },
  data() {
    return {
      items: []
    }
  },
  methods: {
    formattedCompanies(item) {
      let str = map(item.companies, (o) => o.name).join(', ')
      if(!item.campaign_filter) return str
      if(item.campaign_filter_operator === 'contains') return str + ' (only "' + item.campaign_filter + '")'
      else return str + ' (not "' + item.campaign_filter + '")'
    },
    formattedDate(date) {
      return moment(date).format('MMM DD')
    },
    async submit() {
      EventBus.$emit("loading:start")

      let order = map(this.items, function (item) {
        return item.id
      })

      await this.axios
        .post("budget/reorder", {order})
        .then(() => {
          this.$emit("close")
          EventBus.$emit("fetch-settings")
        })

      EventBus.$emit("loading:stop")
    }
  },
  mounted() {
    this.items = this.existing
  }
};
</script>

<style lang="scss" scoped>
</style>
